/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Kit 2 React components
import Grid2 from "@mui/material/Unstable_Grid2";
import ElementCard from "views/Cards/ElementsCards";
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";

// Material Kit 2 React examples
import { categories } from "../../../store/constant/constant";
import ElementsData from "../../../store/constant/elementsCollection";

function KeyElements() {
  return (
    <>
      <Grid2 container my={2}>
        {categories.map((c) =>
          ElementsData.filter((e) => e.category.toLowerCase() === c).map(({ category, items }) => (
            <Grid2 container xs={4} p={1} key={category}>
              <Grid2 container xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                <Grid2 xs={12}>
                  <MKBox
                    display="flex"
                    alignItems="center"
                    sx={{ py: 1, justifyContent: "center" }}
                  >
                    <MKTypography
                      variant="h3"
                      textTransform="capitalize"
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      {category}
                    </MKTypography>
                  </MKBox>
                </Grid2>
                {items.map(({ image, cardTitle, route, itemDescription }) => (
                  <Grid2 xs={12} key={cardTitle} sx={{ display: "flex", justifyContent: "center" }}>
                    <ElementCard
                      image={image}
                      title={cardTitle}
                      action={{
                        type: "internal",
                        route,
                        label: "Indicator",
                      }}
                      description={itemDescription}
                    />
                  </Grid2>
                ))}
              </Grid2>
            </Grid2>
          ))
        )}
      </Grid2>
    </>
  );
}

export default KeyElements;
